/**
 * 404 Not Found Page
 * 
 * Displayed when route doesn't exist.
 */

import { Link } from 'react-router-dom';
import { ROUTES } from '@threadlock/routing';

export default function NotFoundPage() {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col items-center justify-center min-h-[60vh]">
        <h1 className="text-6xl font-bold text-neutral-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-neutral-700 mb-4">Page Not Found</h2>
        <p className="text-neutral-600 mb-8 text-center max-w-md">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to={ROUTES.DASHBOARD}
          className="px-6 py-3 bg-neutral-900 text-white rounded-lg hover:bg-neutral-800 transition-colors"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
